import api from "./client";

// Authentication API
export const authAPI = {
  // Login with email and password
  login: async (email, password) => {
    try {
      const response = await api.post("/login", {
        user: { email, password },
      });

      // Check if we have a valid response with token
      if (response.data?.status?.code === 200 && response.data?.data?.token) {
        return response.data;
      } else {
        throw new Error("No token received from server");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Invalid email or password");
      }
      // The archived-account refusal carries the only wording the user should
      // see. Without this the raw axios error reaches Login.js and it renders
      // "Request failed with status code 403", which explains nothing.
      if (
        error.response?.status === 403 &&
        error.response?.data?.error === "account_archived"
      ) {
        throw new Error(
          error.response.data?.status?.message ||
            "This account has been archived. Please contact your administrator.",
        );
      }
      throw error;
    }
  },

  // Register a new user
  register: async (userData) => {
    const response = await api.post("/users", {
      user: userData,
    });
    return response.data;
  },

  // Create a new client
  createClient: async (clientData) => {
    const response = await api.post("/api/v1/clients", {
      client: clientData,
    });
    return response;
  },

  // Logout
  logout: async () => {
    const response = await api.delete("/users/sign_out");
    return response.data;
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await api.get("/users/me");
    return response.data;
  },

  // Update profile (name)
  updateProfile: async (data) => {
    const response = await api.put("/users", { user: data });
    return response.data;
  },

  // Change password (requires current password)
  updatePassword: async (data) => {
    const response = await api.put("/users", { user: data });
    return response.data;
  },

  // Set password for OAuth users (no current password needed)
  setPassword: async (password, passwordConfirmation) => {
    const response = await api.post("/api/v1/account/set_password", {
      password,
      password_confirmation: passwordConfirmation,
    });
    return response.data;
  },
};

// Password Reset API
export const passwordAPI = {
  requestReset: async (email) => {
    const response = await api.post("/users/password", { user: { email } });
    return response.data;
  },
  resetPassword: async (token, password, passwordConfirmation) => {
    const response = await api.put("/users/password", {
      user: { reset_password_token: token, password, password_confirmation: passwordConfirmation },
    });
    return response.data;
  },
};
